import { render, staticRenderFns } from "./Whoami.vue?vue&type=template&id=1e670d3a&"
import script from "./Whoami.vue?vue&type=script&lang=js&"
export * from "./Whoami.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports